import React from 'react';
import DocumentTextIcon from '@heroicons/react/outline/DocumentTextIcon.js';
import { BlockType } from '../../types/index.js';
import { RichTextBlock as Component } from './Block.js';
import { RichTextBlockSettings as Settings } from './Settings.js';
export const RegisteredRichTextBlock = (intl) => {
    const { $t } = intl;
    return {
        recommendedName: 'RichText',
        Component,
        config: {
            type: BlockType.Block,
            usable: true,
            displayName: $t({
                id: 'Blocks.RichText.DisplayName',
                defaultMessage: 'Rich Text',
            }),
            Settings,
            Icon: React.createElement(DocumentTextIcon, null),
            defaultProps: {
                textColor: 'dark',
                content: '',
            },
        },
    };
};
//# sourceMappingURL=registered.js.map